import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import { flatArrayBrowserCompatibly } from '../../../common/utils';
import Pagination from './_Pagination';
import ColumnFilter from './_ColumnFilterController';
import DataTableCell from './_DataTableCell';

class SimpleDataTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true
    };
    this.refTable = React.createRef();
  }

  async componentDidMount() {
    const {
      props: {
        paginationData,
        getData,
        tableConfig: {
          columns
        }
      }
    } = this;

    let pageNumber = 1;

    if (paginationData && paginationData !== null) {
      ({ pageNumber } = paginationData);
    }

    const rawData = await getData(pageNumber);

    const data = rawData.map(row => {
      const newRow = {};

      columns.forEach(({ property, render }) => {
        newRow[property] = render ? render(row) : row[property];
      });

      newRow.rowData = row;

      return {
        rawData: row,
        processedData: newRow
      };
    });

    this.setState({
      isLoading: false,
      data
    });
  }

  getTableRows(tableColumns, tableItems) {
    return [
      {
        id: uuidv4(), // TODO use a proper id or make possible to override uuid,
        rawRowData: tableItems.tableRowData,
        cells: tableColumns.map(x => ({
          id: uuidv4(), // TODO use a proper id or make possible to override uuid
          cellData: {
            columnHeadingContent: x.columnHeadingContent,
            cellContent: tableItems.tableItemCells.filter(y => y.columnId === x.columnId)[0].cellContent, // TODO?
            attributes: {
              headers: tableColumns.columnId
            }
          }
        }))
      }
    ];
  }

  // todo support nested cells like below
  // tableColumns.map(x => new Object({
  //       uuid: uuidv4(),
  //       celle:
  //     }))]
  //     return [
  //       {
  //         "uuid": "adf45bbd-63a6-41a6-bb01-a9b6a38af66b",
  //         "celle": [
  //           {
  //             "uuid": "13b04be0-e5a0-4fee-bb33-85e3d2485c07",
  //             "cellData": {
  //               "columnHeadingContent": "Id",
  //               "cellContent": "asasd",
  //               "attributes": {
  //                 "headers": "subscriptions-Id"
  //               }
  //             }
  //           },
  //           {
  //             "uuid": "23c4c6c2-04df-4750-844c-78fa60604fcc",
  //             "cellData": {
  //               "columnHeadingContent": "MembershipId",
  //               "cellContent": "asd",
  //               "attributes": {
  //                 "headers": "subscriptions-MembershipId"
  //               }
  //             }
  //           },
  //           {
  //             "uuid": "42cddb50-5122-4c1b-b083-e64d8a5eddac",
  //             "cellData": {
  //               "columnHeadingContent": "a",
  //               "cellContent": "a",
  //               "attributes": {
  //                 "headers": "subscriptions-List-a",
  //                 "className": "table-cell-nested"
  //               }
  //             }
  //           },
  //           {
  //             "uuid": "25277713-0fd5-46b9-ad96-183beffc74a7",
  //             "cellData": {
  //               "columnHeadingContent": "b",
  //               "cellContent": "b",
  //               "attributes": {
  //                 "headers": "subscriptions-List-b",
  //                 "className": "table-cell-nested"
  //               }
  //             }
  //           },
  //           {
  //             "uuid": "d2f3876f-6da0-4b14-bb7b-3403c6c0c88f",
  //             "cellData": {
  //               "columnHeadingContent": "List",
  //               "cellContent": [
  //                 {
  //                   "a": "a",
  //                   "b": "b"
  //                 }
  //               ],
  //               "attributes": {
  //                 "headers": "subscriptions-List",
  //                 "className": "table-cell-group"
  //               },
  //               "nestedCells": [
  //                 [
  //                   {
  //                     "firstRowIndex": 0,
  //                     "columnHeadingContent": "a",
  //                     "columnId": "subscriptions-List-a",
  //                     "cellContent": "a",
  //                     "isNestedCell": true
  //                   },
  //                   {
  //                     "firstRowIndex": 0,
  //                     "columnHeadingContent": "b",
  //                     "columnId": "subscriptions-List-b",
  //                     "cellContent": "b",
  //                     "isNestedCell": true
  //                   }
  //                 ]
  //               ]
  //             }
  //           },
  //           {
  //             "uuid": "606537be-c0b4-4106-ba0f-1bc3230b4785",
  //             "cellData": {
  //               "columnHeadingContent": "Status",
  //               "cellContent": "asd",
  //               "attributes": {
  //                 "headers": "subscriptions-Status"
  //               }
  //             }
  //           },
  //           {
  //             "uuid": "9bd0aaae-a24a-4fb2-9c0c-72780e423ccb",
  //             "cellData": {
  //               "columnHeadingContent": "Text",
  //               "cellContent": "asd",
  //               "attributes": {
  //                 "headers": "subscriptions-Text"
  //               }
  //             }
  //           },
  //           {
  //             "uuid": "8c297b2b-ec3e-4310-b182-b34824aba46e",
  //             "cellData": {
  //               "columnHeadingContent": "CreatedAt",
  //               "attributes": {
  //                 "headers": "subscriptions-CreatedAt",
  //                 "className": "table-cell-empty"
  //               }
  //             }
  //           }
  //         ]
  //       }
  //     ];
  //   };

  processSubComponentData(tableConfig, data) {
    const {
      tableName,
      columns,
      rowClasses = '',
      rowClick = null
    } = tableConfig;

    let tableColumns = columns
      .filter(x => !x.columns) // TODO support nested properties
      .map(({ property, label, columns: rowColumns }) => ({
        columnHeadingContent: label,
        columnId: `${tableName}-${property}`,
        columnTitle: property,
        isGroupColumn: rowColumns && rowColumns.length > 0
      }));

    // TODO supporting more than one level of nested properties
    const nested = flatArrayBrowserCompatibly(columns
      .filter(x => !x.columns) // TODO support nested properties
      .filter(x => x.columns && x.columns.length > 0)
      .map(parent => parent.columns.map(x => ({
        columnHeadingContent: x.label,
        columnId: `${tableName}-${parent.property}-${x.property}`,
        columnTitle: x.property
      })))
    );

    tableColumns = tableColumns.concat(nested);

    const tableItems = data.map(x => ({
      itemRowsLen: 1,
      tableRowData: x.rawData,
      tableItemCells: tableColumns.map(({ columnHeadingContent, columnId, columnTitle, isNestedCell }) => ({
        firstRowIndex: 0,
        columnHeadingContent,
        columnId,
        isNestedCell,
        cellContent: isNestedCell ? 'nested' : x.processedData[columnTitle]
      }))
    }));


    // TODO handle nested cells case like in data here
    // tableItems: [
    //   {
    //     "itemRowsLen": 1,
    //     "tableItemCells": [
    //       {
    //         "firstRowIndex": 0,
    //         "columnHeadingContent": "a",
    //         "columnId": "subscriptions-List-a",
    //         "cellContent": "a",
    //         "isNestedCell": true
    //       },
    //       {
    //         "firstRowIndex": 0,
    //         "columnHeadingContent": "b",
    //         "columnId": "subscriptions-List-b",
    //         "cellContent": "b",
    //         "isNestedCell": true
    //       },
    //       {
    //         "firstRowIndex": 0,
    //         "columnHeadingContent": "MembershipId",
    //         "columnId": "subscriptions-MembershipId",
    //         "cellContent": "asd",
    //         "isNestedCell": false
    //       },
    //       {
    //         "cellContent": [
    //           {
    //             "a": "a",
    //             "b": "b"
    //           }
    //         ],
    //         "spannedRows": 1,
    //         "nestedCells": [
    //           [
    //             {
    //               "firstRowIndex": 0,
    //               "columnHeadingContent": "a",
    //               "columnId": "subscriptions-List-a",
    //               "cellContent": "a",
    //               "isNestedCell": true
    //             },
    //             {
    //               "firstRowIndex": 0,
    //               "columnHeadingContent": "b",
    //               "columnId": "subscriptions-List-b",
    //               "cellContent": "b",
    //               "isNestedCell": true
    //             }
    //           ]
    //         ],
    //         "firstRowIndex": 0,
    //         "columnHeadingContent": "List",
    //         "columnId": "subscriptions-List",
    //         "isNestedCell": false
    //       },

    return {
      tableColumns,
      tableItems,
      rowClasses,
      rowClick
    };
  }

  render() {
    const {
      refTable,
      props,
      state: {
        isLoading,
        data
      },
      processSubComponentData
    } = this;

    const {
      cellVerticalAlign = 'middle',
      languageCode = 'en',
      labels,
      hideTableHead,
      tableConfig,
      loadingContent = (<span>Loading...</span>),
      skipTableNoResults
    } = props;

    if (isLoading) {
      return loadingContent;
    }

    if (!data) {
      return <span>No Data</span>;
    }

    const { length: dataLength } = data;


    let { paginationData } = props;

    const processedData = processSubComponentData(tableConfig, data);
    const {
      tableColumns,
      tableItems,
      rowClasses,
      rowClick
    } = processedData;
    const dataTableClasses = [
      'data-lists',
      'component-data-table',
      `cell-content-align-${cellVerticalAlign}`
    ];

    if (dataLength < 1) {
      dataTableClasses.push('data-table-no-results');
    }

    const tableAttributes = {
      className: dataTableClasses.join(' ')
    };

    const columnCount = tableColumns.length;

    paginationData = paginationData ? {
      ...paginationData,
      languageCode,
      columnCount,
      rowCount: dataLength,
      refParentTable: refTable
    } : undefined;

    const { renderLocation } = paginationData;

    const { tableBody = {} } = labels;

    return (
      <article className='data-table-wrap'>
        <table ref={refTable} {...tableAttributes}>
          {hideTableHead || (skipTableNoResults && tableItems.length === 0) ? '' : (
            <thead>
              {renderLocation === 'top' || renderLocation === 'both' ? <Pagination {...paginationData} /> : null}

              <tr>
                {tableColumns.map(columnData => {
                  const classNames = [];
                  const {
                    columnId,
                    columnTitle,
                    isGroupColumn,
                    columnTextAlign,
                    classNames: columnClassNames,
                    dataFilter
                  } = columnData;

                  let { columnHeadingContent: tableHeadingContent } = columnData;

                  // Add special class names to group headings:
                  if (isGroupColumn) {
                    classNames.push('table-cell-group');
                  }

                  // Add special class names to aligned columns:
                  if (columnTextAlign) {
                    classNames.push(`column-align-${columnTextAlign}`);
                  }

                  // Add classnames if defined:
                  if (columnClassNames) {
                    classNames.push(...columnClassNames);
                  }

                  if (dataFilter) {
                    classNames.push('table-heading-filter');

                    const {
                      filterData,
                      filterOptions,
                      renderOptionLabel
                    } = dataFilter;

                    tableHeadingContent = (
                      <ColumnFilter
                        filteredColumnId={columnId}
                        filteredColumnTitle={columnTitle}
                        languageCode={languageCode}
                        placeholderContent={tableHeadingContent}
                        filterOptions={filterOptions}
                        renderOptionLabel={renderOptionLabel}
                        filterData={filterData}
                      />
                    );
                  }

                  return <th id={columnId} key={columnId} className={classNames.join(' ')}>{tableHeadingContent}</th>;
                })}
              </tr>
            </thead>
          )}

          {tableItems.length > 0 ? tableItems.map(tableItemData => (
            // TODO use a proper id or make possible to override uuid
            <tbody key={uuidv4()}>
              {
                this.getTableRows(tableColumns, tableItemData)
                  .map(({ id: rowId, cells, rawRowData }) => (
                    <tr
                      onClick={() => {
                        if (rowClick) {
                          rowClick(rawRowData);
                        }
                      }}
                      key={rowId}
                      className={rowClasses}
                    >
                      {cells.map(({ id: cellId, cellData }) => (<DataTableCell key={cellId} cellData={cellData} />))
                      }
                    </tr>
                  ))
              }
            </tbody>
          )) : (
            <tbody key={uuidv4()}>
              <tr className={rowClasses}>
                <td className='cell-no-result' colSpan={columnCount}>
                  {tableBody.noResult || 'no results'}
                </td>
              </tr>
            </tbody>
          )}
          <tfoot>
            {renderLocation === 'bottom' || renderLocation === 'both' ? <Pagination {...paginationData} /> : null}
          </tfoot>
        </table>
      </article>
    );
  }
}

export default SimpleDataTable;